export const IS_DEV = process.env.NODE_ENV === 'development';

export const IS_QA = process.env.REACT_APP_DEPLOYMENT === 'QA';
export const IS_PROD = process.env.REACT_APP_DEPLOYMENT === 'PROD';

export const IS_DEV_QA = IS_DEV || IS_QA;

export const IS_MAC = /mac/i.test(navigator.userAgentData?.platform || navigator.platform);
